// Wizard steps. Integrations that add new hires get one more, right after the pull.
export function wizardSteps(withNewHires) {
    const steps = [{key: 'start', lines: ['Start', 'Import']}]
    if (withNewHires) {
        steps.push({key: 'new-hires', lines: ['New', 'Hires']})
    }
    steps.push({key: 'review', lines: ['Review', 'Issues']})
    steps.push({key: 'final', lines: ['Final', 'Review']})
    return steps
}

// Rows needing attention first, then store, then name. Applied once on load,
// so rows don't move while the manager is editing them.
export function sortForReview(rows) {
    const key = row => [
        row.status == 'attention' ? 0 : 1,
        String(row.store).padStart(20, '0'),
        (row.values.last_name || '').toUpperCase(),
        (row.values.first_name || '').toUpperCase(),
    ]

    return [...rows].sort((a, b) => {
        const ka = key(a)
        const kb = key(b)
        for (let i = 0; i < ka.length; i++) {
            if (ka[i] < kb[i]) {
                return -1
            }
            if (ka[i] > kb[i]) {
                return 1
            }
        }
        return a.idx - b.idx
    })
}

export function filterRows(rows, filter) {
    return filter == 'all' ? rows : rows.filter(row => row.status == filter)
}

// The fields edited inline on each row; the "set for all" row above them uses the same list.
export function quickFields(choices) {
    const fields = [{name: 'pay_rate', label: 'Pay rate', width: '6rem'}]
    choices.org_levels.forEach(orgLevel => {
        fields.push({name: orgLevel.field, label: orgLevel.label, width: '12rem', options: orgLevel.options, blank: true})
    })
    if (choices.paygroup.length) {
        fields.push({
            name: 'paygroup',
            label: 'Pay group',
            width: '9rem',
            options: choices.paygroup.map(paygroup => ({value: paygroup, text: paygroup})),
            blank: true,
        })
    }
    fields.push({name: 'employment_category', label: 'PT/FT', width: '8rem', options: choices.employment_category})
    return fields
}

export function displayName(values) {
    return `${values.last_name || ''}, ${values.first_name || ''}`.toUpperCase()
}

// Two changes to one row as a single change; b is the later one.
export function mergeChange(a, b) {
    if (!a) {
        return b
    }
    if (!b) {
        return a
    }

    const merged = {}
    if (a.values || b.values) {
        merged.values = {...(a.values || {}), ...(b.values || {})}
    }
    if ('skip' in b) {
        merged.skip = b.skip
    } else if ('skip' in a) {
        merged.skip = a.skip
    }
    return merged
}

// One save in flight per row. Edits made meanwhile are merged and sent next,
// so the server never sees a row's saves out of order.
export class RowSaveQueue {
    constructor(send, onStatus) {
        this.send = send
        this.onStatus = onStatus
        this.inFlight = {}
        this.queued = {}
        this.failed = {}
    }

    enqueue(idx, change) {
        this.queued[idx] = mergeChange(this.queued[idx] || this.failed[idx], change)
        delete this.failed[idx]
        this.flush(idx)
    }

    retry(idx) {
        if (!this.failed[idx]) {
            return
        }
        this.queued[idx] = this.failed[idx]
        delete this.failed[idx]
        this.flush(idx)
    }

    flush(idx) {
        if (this.inFlight[idx] || !this.queued[idx]) {
            return
        }

        const change = this.queued[idx]
        delete this.queued[idx]
        this.inFlight[idx] = true
        this.onStatus(idx, 'saving')

        this.send(idx, change).then(response => {
            this.inFlight[idx] = false
            if (this.queued[idx]) {
                this.flush(idx)
            } else {
                this.onStatus(idx, 'saved', response)
            }
        }).catch(() => {
            this.inFlight[idx] = false
            this.failed[idx] = mergeChange(change, this.queued[idx])
            delete this.queued[idx]
            this.onStatus(idx, 'failed')
        })
    }
}
